/**
 * Marca "Game of Brasil": o wordmark (assets/title.png, 572×60, copiado do
 * card-game-app), a linha de "batimento" ciano e o subtítulo em versalete.
 * Espelha src/components/BrandMark.tsx do app para que site e jogo tenham
 * exatamente a mesma assinatura visual.
 */

/** Proporção original da arte do título — mantém o wordmark sem distorção. */
const TITLE_ASPECT = 572 / 60;

/** A linha ciano com um "batimento" no centro, sob o wordmark. */
function Waveform(): React.JSX.Element {
  const w = 520;
  const h = 16;
  const mid = h / 2;
  const c = w / 2;
  const points = [
    `0,${mid}`,
    `${c - 44},${mid}`,
    `${c - 26},${mid}`,
    `${c - 14},3`,
    `${c},${h - 2}`,
    `${c + 14},2`,
    `${c + 26},${mid}`,
    `${c + 44},${mid}`,
    `${w},${mid}`,
  ].join(' ');

  return (
    <svg className="waveform" viewBox={`0 0 ${w} ${h}`} role="presentation" aria-hidden>
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BrandMark({ subtitle }: { subtitle?: string }): React.JSX.Element {
  return (
    <div className="brandmark">
      <img
        src={`${import.meta.env.BASE_URL}title.png`}
        alt="Game of Brasil"
        width={572}
        height={60}
        style={{ aspectRatio: String(TITLE_ASPECT) }}
      />
      <Waveform />
      {subtitle ? <p className="tagline">{subtitle}</p> : null}
    </div>
  );
}
